export const minFname = 'First Name is too Short!';
export const maxFname = 'First Name is too Long!';
export const minLname = 'Last Name is too Short!';
export const maxLname = 'Last Name is too Long!';
export const phone = 'Phone Number is not valid!';
export const minCity = 'City Name is too Short!';
export const maxCity = 'City Name is too Long!';

export const email = 'Email is Invalid!';
export const minSummary = 'Summary is too Short!';
export const maxSummary = 'You are out of limit!';
// EmployeeExperience
export const minTitle = 'Title is too Short!';
export const maxTitle = 'Title is too Long!';
export const minDescription = 'Job Description is too Short!';
export const maxDescription = 'You are out of limit!';

export const minOrganization = 'Organization Name is too Short!';
export const maxOrganization = 'Organization Name is too Long!';

export const skills = 'Add atleast 3 skills!';
export const interest = 'Add atleast 3 interest!';
// EmployeeEduaction
export const minSchool = 'Institution Name is too Short!';
export const maxSchool = 'Institution Name is too Long!';

export const minDegree = 'Diploma/Degree Name is too Short!';
export const maxDegree = 'Diploma/Degree Name is too Long!';

export const minStudy = 'Field of Study is too Short!';
export const maxStudy = 'Field of Study is too Long!';

// EmployeeExperience
export const startDate = 'Start Date is required!';
export const futureDate = 'Future date cannot be selected!';
